export class LocalStorage {
    public static instance: LocalStorage;
    private clientAppPrefix;
    private static username;

    private constructor(clientAppPrefix: string) {
        this.clientAppPrefix = clientAppPrefix;
    }

    public static init(clientAppPrefix: any): any {
        this.instance = new LocalStorage(clientAppPrefix);
        LocalStorage.username = LocalStorage.instance.getItem("sislogUsername");
        window.addEventListener("storage", () => {
            if (LocalStorage.username != null
                // tslint:disable-next-line: triple-equals
                && LocalStorage.instance.getItem("sislogUsername") != LocalStorage.username) {
                window.location.reload();
            }
          });
    }

    public getItem(key: string): any {
        return localStorage.getItem(this.clientAppPrefix + "_" + key);
    }
    private setItem(key: string, value: any): void {
        localStorage.setItem(this.clientAppPrefix + "_" + key, value);
    }
    private removeItem(key: string): void {
        localStorage.removeItem(this.clientAppPrefix + "_" + key);
    }
    public static setLogin(username: string, uid: string, login: string): void {
        LocalStorage.username = username;
        LocalStorage.instance.setItem("sislogUsername", username);
        LocalStorage.instance.setItem("sislogUid", uid);
        LocalStorage.instance.setItem("sislogLogin", login);
    }

    public static getUid(): any {
        return LocalStorage.instance.getItem("sislogUid");
    }

    public static getLogin(): any {
        return LocalStorage.instance.getItem("sislogLogin");
    }

    public static getUsername(): any {
        return LocalStorage.instance.getItem("sislogUsername");
    }

    public static clearUser(): void {
        LocalStorage.username = undefined;
        LocalStorage.instance.removeItem("sislogUsername");
        LocalStorage.instance.removeItem("sislogUid");
    }
}
